module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Bold.8cd5c6a7dda9a200203640a03817170e.woff";